import actions from './actions-supplier.js'
import mutations from './mutations-supplier.js'
import getters from './getters-supplier.js'
import state from './state-supplier.js'

export default {
    namespaced: true,
    actions,
    mutations,
    getters,
    state
}